import Splide from '@splidejs/splide';

export const makeCarousel = (carouselEl, options) => new Splide(carouselEl, options).mount();
export const makeUnmountedCarousel = (carouselEl, options) => new Splide(carouselEl, options);
